import {emptyTank, api, actions} from '../constants/tanks_constants.js';
import { request_helper } from "./request_helper.js";
import i18n, { getIso } from '../utils/localizations.jsx';
import { utils } from "../utils/utils";
import { authenticationService } from "../services/authenticationService.js";

export const actionTanks = {
    getTanks: (filter) => async (dispatch, getState) => {
        dispatch({ type: actions.START_REQUEST });
        const url = api.GET_TANKS_LIST_API;
        let postData = {
            pageNumber: filter.pagesFilter.currentPage,
            modelFilter: {},
            sortFilter: {}
        }
        try {
            const data = await request_helper.callWithDispatch(dispatch, "POST", url, postData);
            let tanks = {
                items: data.items,
                filter: { pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage } }
            }
            dispatch({ type: actions.GET_TANKS, tanks });
        } catch (error) {
            return;
        }
    },
    getTank: (tankId) => async (dispatch, getState) => {
        if (tankId === 0) {
            dispatch({ type: actions.GET_CURRENT_TANK, tank: Object.assign({}, emptyTank) });
            return;
        }
        const url = api.GET_TANK_API + "?tankId=" + tankId;

        try {
            const data = await request_helper.callWithDispatch(dispatch, "GET", url);
            dispatch({ type: actions.GET_CURRENT_TANK, tank: data });
            return;
        } catch (error) {
            dispatch({ type: actions.GET_CURRENT_TANK, tank: Object.assign({}, emptyTank) });
        }
    },
    addTank: (tank, graduationFile, ownProps) => async (dispatch, getState) => {
        const url = api.ADD_TANK_API;
        try {
            if (graduationFile) {
                const data = await request_helper.uploadFileWithDispatch(dispatch, api.UPLOAD_GRADUATIONS, graduationFile);
                console.log(data);
                let fileId = parseInt(data);
                tank.graduationFileId = fileId;
            };
            tank = await request_helper.callWithDispatch(dispatch, "POST", url, tank);
            dispatch({ type: actions.ADD_TANK, tank });
            ownProps.history.goBack();
        } catch (error) {
            return;
        }
    },
    editTank: (tank, graduationFile, ownProps) => async (dispatch, getState) => {
        const url = api.EDIT_TANK_API;
        try {
            if (graduationFile) {
                const data = await request_helper.uploadFileWithDispatch(dispatch, api.UPLOAD_GRADUATIONS, graduationFile);
                console.log(data);
                let fileId = parseInt(data);
                tank.graduationFileId = fileId;
            };
            tank = await request_helper.callWithDispatch(dispatch, "POST", url, tank);
            dispatch({ type: actions.EDIT_TANK, tank });
            ownProps.history.goBack();
        } catch (error) {
            return;
        }
    },
    getAreas: () => async (dispatch, getState) => {
        const url = api.GET_AREAS_API;
        try {
            dispatch({ type: actions.START_REQUEST });
            const areas = await request_helper.callWithDispatch(dispatch, "GET", url);
            dispatch({ type: actions.GET_AREAS, areas });
        } catch (error) {
            return;
        }
    },
    addArea: (area, ownProps) => async (dispatch, getState) => {
        const url = api.ADD_AREA_API;
        try {
            area = await request_helper.callWithDispatch(dispatch, "POST", url, area);
            dispatch({ type: actions.ADD_AREA, area });
            ownProps.history.goBack();
        } catch (error) {
            return;
        }
    },
    editArea: (area) => async (dispatch, getState) => {
        const url = api.EDIT_AREA_API;
        try {
            area = await request_helper.callWithDispatch(dispatch, "POST", url, area);
            dispatch({ type: actions.EDIT_AREA, area });
        } catch (error) {
            return;
        }
    },
    getTankOperations: (filter) => async (dispatch, getState) => {
        //dispatch({ type: actions.START_REQUEST });
        const url = api.GET_TANK_OPERATIONS_API;
        const postData = {
            pageNumber: filter.pagesFilter.currentPage,
            modelFilter: filter.modelFilter,
            sortFilter: {}
        }
        try {
            const data = await request_helper.callWithDispatch(dispatch, "POST", url, postData);
            const tankOperations = {
                items: data.items,
                filter: {
                    pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                    modelFilter: filter.modelFilter,
                    sortFilter: filter.sortFilter
                }
            }
            //dispatch({ type: actions.END_REQUEST, tanks });
            return tankOperations;
        } catch (error) {
            return null;
        }
    },
    getTanksStateOperations: (filter) => async (dispatch, getState) => {
        dispatch({ type: actions.START_REQUEST });
        const url = api.GET_TANKS_STATE_OPERATIONS_API;
        const postData = {
            pageNumber: filter.pagesFilter.currentPage,
            modelFilter: filter.modelFilter,
            sortFilter: {}
        }
        try {
            const data = await request_helper.callWithDispatch(dispatch, "POST", url, postData);
            const tanksStateOperations = {
                items: data.items,
                filter: {
                    pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                    modelFilter: filter.modelFilter,
                    sortFilter: filter.sortFilter
                }
            }
            dispatch({ type: actions.GET_TANKS_STATE_OPERATIONS, tanksStateOperations });
            return tanksStateOperations;
        } catch (error) {
            return null;
        }
    },
    getTanksOperations: (filter) => async (dispatch, getState) => {
        dispatch({ type: actions.START_REQUEST });
        const url = api.GET_TANK_OPERATIONS_API;
        const postData = {
            pageNumber: filter.pagesFilter.currentPage,
            modelFilter: filter.modelFilter,
            sortFilter: {}
        }
        try {
            const data = await request_helper.callWithDispatch(dispatch, "POST", url, postData);
            const tankOperations = {
                items: data.items,
                filter: {
                    pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                    modelFilter: filter.modelFilter,
                    sortFilter: filter.sortFilter
                }
            }
            dispatch({ type: actions.GET_TANKS_OPERATIONS, tankOperations });
            return tankOperations;
        } catch (error) {
            return null;
        }
    },
    addTankOperation: (tankOperation, ownProps) => async (dispatch, getState) => {
        const url = api.ADD_TANK_OPERATIONS_API;
        //const getTankurl = api.GET_TANK_API + "?tankId=" + tankOperation.tankId;
        try {
            dispatch({ type: actions.START_REQUEST });
            tankOperation = await request_helper.callWithDispatch(dispatch, "POST", url, tankOperation);
            //const tank = await request_helper.callWithDispatch(dispatch, "GET", getTankurl);
            //dispatch({ type: actions.EDIT_TANK, tank });
            ownProps.history.goBack();
        } catch (error) {
            return;
        }
    },
    getOperationsReport: (filter) => async (dispatch, getState) => {
        dispatch({ type: actions.START_REQUEST });
        const url = api.GET_TANK_OPERATIONS_REPORT_API;

        const postData = {
            pageNumber: filter.pagesFilter.currentPage,
            modelFilter: filter.modelFilter,
            sortFilter: {}
        }

        try {
            const response = await request_helper.callWithDispatchReport(dispatch, "POST", url, postData);
            dispatch({ type: actions.END_REQUEST });
            return response;
        }
        catch (error) {
            dispatch({ type: actions.END_REQUEST });
        }
    },
    getTankStateOperationsReport: (filter) => async (dispatch, getState) => {
        dispatch({ type: actions.START_REQUEST });
        const url = api.GET_TANKS_STATE_OPERATIONS_REPORT_API;

        const postData = {
            pageNumber: filter.pagesFilter.currentPage,
            modelFilter: filter.modelFilter,
            sortFilter: {}
        }
        
        try {
            const response = await request_helper.callWithDispatchReport(dispatch, "POST", url, postData);
            dispatch({ type: actions.END_REQUEST });
            return response;
        }
        catch (error) {
            dispatch({ type: actions.END_REQUEST });
        }
    },
    getGraduationsFile: (fileId) => async (dispatch, getState) =>{
        dispatch({ type: actions.START_REQUEST });
        const url = `${api.DOWNLOAD_GRADUATIONS}?fileId=${fileId}`;

        try {
            const response = await request_helper.downloadFileWithDispatch(dispatch, url);
            dispatch({ type: actions.END_REQUEST });
            return response;
        }
        catch (error) {
            dispatch({ type: actions.END_REQUEST });
        }
    }
};
